import React, { useState } from "react";

const PriorityReviewInfoPopover: React.FC = () => {
  const [show, setShow] = useState(false);

  return (
    <div
      className="position-relative d-inline-flex align-items-center"
      onMouseEnter={() => setShow(true)}
      onMouseLeave={() => setShow(false)}
    >
      <i
        className="bi bi-info-circle text-secondary"
        style={{ fontSize: "0.85rem", cursor: "pointer" }}
      ></i>
      {show && (
        <div
          className="position-absolute bg-white border rounded shadow"
          style={{
            top: "100%",
            right: 0,
            marginTop: "6px",
            width: "360px",
            zIndex: 9999,
            padding: "16px 18px",
            fontSize: "0.82rem",
            lineHeight: "1.6",
          }}
        >
          <h6 className="fw-semibold mb-2" style={{ fontSize: "0.85rem" }}>
            Review mode in Priority
          </h6>
          <ul
            className="mb-2 ps-3"
            style={{ listStyleType: "disc", fontSize: "11px" }}
          >
            <li>
              Enable Review mode to review changes across all PLs before saving.
            </li>
            <li>
              Click on the <em>Review Priority</em> to review all changes.
            </li>
            <li>Up to 7 PLs can be updated at a time.</li>
            <li>
              Review mode will be enabled automatically on the next visit if you
              enable it now.
            </li>
            <li>
              <strong>On the Review screen,</strong>
              <ul className="mt-1 ps-3" style={{ listStyleType: "circle" }}>
                <li>Priority title can be edited inline.</li>
                <li>
                  Use the same title across all PLs by clicking on the copy
                  icon.
                </li>
                <li>
                  Change the position by clicking on the{" "}
                  <em>position number</em>. It takes you to the PL and allows
                  all changes.
                </li>
                <li>
                  Click on <em>Save</em> to save all changes.
                </li>
                <li>
                  Failures on saving are highlighted in red with a message.
                </li>
                <li>
                  Click on <em>Retry</em> to reload failed PLs and try again.
                </li>
              </ul>
            </li>
          </ul>
        </div>
      )}
    </div>
  );
};

export default PriorityReviewInfoPopover;
